export { _getAssetsByUserGroup as getAssetsByUserGroup };
export { _getAssetTypesByUserGroup as getAssetTypesByUserGroup };
export { _getCustomFieldsByUserGroup as getCustomFieldsByUserGroup };

const _getAssetsByUserGroup = (params) => {
  return [
    {
      userGroupName: "User_Geospark",
      id: "9f0e8c23-1f46-4541-9c41-669eb9e4ad2c",
      title: "Disney HQ (Tampa)",
      location: {
        latitude: 90,
        longitude: 180,
      },
      creationTimestamp: "",
      assetType: {
        id: "53e0ebd5-8c2c-472d-9909-ed4e61a13e22",
        name: "Headquarters (HQ)",
        icon: "star",
        color: "black",
      },
      customFields: {
        region: "West Africa",
        division: "Mission Solutions",
      },
      lastUpdatedTimestamp: "",
      expirationDate: "",
    },
    {
      userGroupName: "User_Geospark",
      id: "9f0e8c23-1f46-4541-9c41-669eb9e4ad2z",
      title: "Ajinomoto Health & Nutrition North America, Inc.",
      location: {
        latitude: 35.7708414996749,
        longitude: -78.565728000081,
      },
      creationTimestamp: "",
      assetType: {
        id: "40b43aaa-04aa-4e03-8837-fba40c2acf39",
        name: "Office",
        icon: "star",
        color: "black",
      },
      customFields: {
        address: "4020 Ajinomoto Drive, Raleigh, NC 27610",
        region: "North America",
        division: "LS&AM",
      },
      lastUpdatedTimestamp: "",
      expirationDate: "",
    },
  ];
};

const _getAssetTypesByUserGroup = () => {
  return [
    //FAKE DATA
    {
      userGroupName: "User_Geospark",
      assetTypeId: "53e0ebd5-8c2c-472d-9909-ed4e61a13e22",
      name: "Headquarters (HQ)",
      icon: "star",
      color: "black",
      creationTimestamp: "",
      isActive: true,
      isSystem: true,
    },
    {
      userGroupName: "User_Geospark",
      assetTypeId: "40b43aaa-04aa-4e03-8837-fba40c2acf39",
      name: "Office",
      icon: "taco",
      color: "yellow",
      creationTimestamp: "",
      isActive: true,
      isSystem: false,
    },
    {
      userGroupName: "User_Geospark",
      assetTypeId: "40b43aaa-04aa-4e03-8837-fba40c2acf40",
      name: "Custom 2",
      icon: "taco",
      color: "yellow",
      creationTimestamp: "",
      isActive: true,
      isSystem: false,
    },
  ];
};

const _getCustomFieldsByUserGroup = () => {
  return [
    {
      id: "e4b2e2d5-a71f-49e5-a1f5-ebab6d05bdea",
      userGroupName: "User_Geospark",
      name: "Address",
      isActive: true,
      creationTimestamp: "",
    },
    {
      id: "46af007b-93f2-4f6e-ad02-e9430003a903",
      userGroupName: "User_Geospark",
      name: "Region",
      isActive: false,
      creationTimestamp: "",
    },
    {
      id: "fae7074c-50be-4228-8945-f33eab6aea81",
      userGroupName: "User_Geospark",
      name: "Division",
      isActive: true,
      creationTimestamp: "",
    },
  ];
};
